import {
  PLAY_OR_PAUSE,
  NEXT,
  PREV,
  MUTE_UNMUTE,
  VOLUME_CHANGE,
  PLAY,
  SET_TIME,
  AUDIO_ENDED,
  SHUFFLE,
  LINEAR,
  REPEAT,
  REPEAT_1,
} from "../types"
import { Dispatch } from "redux"

export const playOrPause = () => (dispatch: Dispatch) => {
  dispatch({
    type: PLAY_OR_PAUSE,
  })
}

export const playIcon = () => (dispatch: Dispatch) => {
  dispatch({
    type: PLAY,
  })
}

export const nextSong = () => (dispatch: Dispatch) => {
  dispatch({
    type: NEXT,
  })
}

export const prevSong = () => (dispatch: Dispatch) => {
  dispatch({
    type: PREV,
  })
}

export const muteUnmute = () => (dispatch: Dispatch) => {
  dispatch({
    type: MUTE_UNMUTE,
  })
}

export const volumeChange = (value: number) => (dispatch: Dispatch) => {
  dispatch({
    type: VOLUME_CHANGE,
    payload: value,
  })
}

export const setTime = (value: number) => (dispatch: Dispatch) => {
  dispatch({
    type: SET_TIME,
    payload: value,
  })
}

export const audioEnded = () => (dispatch: Dispatch) => {
  dispatch({
    type: AUDIO_ENDED,
  })
}

export const shuffle = () => (dispatch: Dispatch) => {
  dispatch({
    type: SHUFFLE,
    payload: SHUFFLE,
  })
}

export const linear = () => (dispatch: Dispatch) => {
  dispatch({
    type: LINEAR,
    payload: LINEAR,
  })
}

export const repeat = () => (dispatch: Dispatch) => {
  dispatch({
    type: REPEAT,
    payload: REPEAT,
  })
}

export const repeatOne = () => (dispatch: Dispatch) => {
  dispatch({
    type: REPEAT_1,
    payload: REPEAT_1,
  })
}
